var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-video-player"},[_c('video',{ref:"player",attrs:{"playsinline":"","controls":""}},[_c('source',{attrs:{"src":_vm.video,"type":"video/mp4"}})]),_c('b-loading',{attrs:{"is-full-page":false},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }